import _home from "@/views/layouts/home/_home.vue";
import _activity from "@/views/layouts/activity/index.vue";

export default [
    {
        path: "/",
        name: "_home",
        redirect: "/index",
        component:_activity,
        children: [
            {
                path: "/index/:item_id/:matchid",
                name: "index",
                component: () => import(/* webpackChunkName: "home" */"../views/Home/Index.vue"),
                meta: {
                    title: "2023年城市业余联赛",
                    share: true,
                    requiresAuth: false,
                    showloading: false
                }
            },
            // {
            //     path: "/index",
            //     name: "index",
            //     component: () => import(/* webpackChunkName: "home" */"../views/Match/Index/index.vue"),
            //     meta: {
            //         title: "2022年体锻达标赛",
            //         share: true,
            //         requiresAuth: false,
            //         showloading: false,
            //         bgcolor:"#F5F5F5"
            //     }
            // },
            {
                path: "/health",
                name: "health",
                component: () => import(/* webpackChunkName: "exchange" */"../views/Health/Index/index.vue"),
                meta: {
                    title: "健康课堂",
                    share: true,
                    showloading: false,
                    requiresAuth: true,
                    keepAlive: true
                }
            },        
            {
                path: "/exchange",
                name: "exchange",
                component: () => import(/* webpackChunkName: "exchange" */"../views/Exchange/Index/index.vue"),
                meta: {
                    title: "积分乐换",
                    showloading: false,
                    requiresAuth: true,
                    share: true,
                    keepAlive: true
                }
            },
            
            {
                path: "/my",
                name: "my",
                component: () => import(/* webpackChunkName: "my" */"../views/My/Index/index.vue"),
                meta: {
                    title: "个人中心",
                    showloading: false,
                    requiresAuth: true,
                    bgcolor:"#F5F5F5"
                }
            }
        ]
    },
    {
        path: "/activity/luckdraw/:acid?",
        name: "luckdraw",
        component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/LuckDraw/Index.vue"),
        meta: {
            title: "幸运抽奖",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/rule",
        name: "rule",
        component: () => import(/* webpackChunkName: "my" */"../views/Match/Rule/index.vue"),
        meta: {
            title: "线上达标赛",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#fff"
        }
    },
    {
        path: "/move/:matchid",
        name: "Move",
        component: () => import(/* webpackChunkName: "home" */"../views/Move/index.vue"),
        meta: {
            title: "2023年城市业余联赛",
            share: true,
            requiresAuth: true,
            showloading: true,
            bgcolor:"#cfecfc"
        }
    },
    {
        path: "/five/:matchid",
        name: "MoveF",
        component: () => import(/* webpackChunkName: "home" */"../views/Move/five.vue"),
        meta: {
            title: "2023年城市业余联赛",
            share: true,
            requiresAuth: true,
            showloading: true,
            bgcolor:"#ffffff"
        }
    },
    {
        path: "/healthdetail/:vid/:mediaurl",
        name: "healthdetail",
        component: () => import(/* webpackChunkName: "activity" */"../views/Health/Detail/index.vue"),
        meta: {
            title: "健康小视频",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/my",
        name: "myorder",
        component: () => import(/* webpackChunkName: "my" */"../views/My/Index/index.vue"),
        meta: {
            title: "个人中心",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/exchangedetail/:goodsid?",
        name: "exchangedetail",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Exchange/Detail/index.vue"),
        meta: {
            title: "详情",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/orderconfirm/:orderid/:uaid?",
        name: "orderConfirm",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Exchange/OrderConfirm/index.vue"),
        meta: {
            title: "订单确认",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/mwap/:id?",
        name: "mwap",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Mwap/Index/index.vue"),
        meta: {
            title: "挑战卡路里",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/challengerecord",
        name: "challengeRecord",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/Mwap/Record/index.vue"),
        meta: {
            title: "我的挑战",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/address/:selectid?",
        name: "addressList",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Address/Index/index.vue"),
        meta: {
            title: "地址",
            showloading: false,
        }
    },
    {
        path: "/voteresult/:item_sub_id/:matchid",
        name: "sportsResultVote",
        component: () => import(/* webpackChunkName: "home" */"../views/Mwap/Detail/result.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"投票"
        }
    },
    {
        path: "/mwapdetail/:item_sub_id/:matchid",
        name: "sportsDetail",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Mwap/Detail/index.vue"),
        meta: {
            title: "详情",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/sports/join/:item_sub_id/:matchid",
        name: "joinSports",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Mwap/SignUp/index.vue"),
        meta: {
            title: "开始挑战",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/sports/rank/:item_sub_id/:matchid/:item_id?",
        name: "sportsRank",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Mwap/Rank/index.vue"),
        meta: {
            title: "挑战排行榜",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/sports/result/:item_sub_id/:matchid",
        name: "sportsResult",
        component: () => import(/* webpackChunkName: "home" */"../views/Mwap/Result/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"我的"
        }
    },
    {
        path: "/wholefamily",
        name: "wholefamily",
        component: () => import(/* webpackChunkName: "exchange" */"../views/WholeFamily/Index/index.vue"),
        meta: {
            title: "全家总动员",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/familydetail",
        name: "familydetail",
        component: () => import(/* webpackChunkName: "exchange" */"../views/WholeFamily/Detail/index.vue"),
        meta: {
            title: "全家总动员",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/familysignup",
        name: "familysignup",
        component: () => import(/* webpackChunkName: "exchange" */"../views/WholeFamily/SignUp/index.vue"),
        meta: {
            title: "我要报名",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/familyrecord",
        name: "familyrecord",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/WholeFamily/Record/index.vue"),
        meta: {
            title: "我的全家总动员",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/vote",
        name: "vote",
        component: () => import(/* webpackChunkName: "exchange" */"../views/WholeFamily/Vote/index.vue"),
        meta: {
            title: "我要投票",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/activity",
        name: "_activity",
        component: _activity,
        children: [
            {
                path: "/activity/:acid",
                name: "answer",
                component: () => import(/* webpackChunkName: "activity" */"../views/Activity/Answer/Index.vue"),
                meta: {
                    title: "天天答题",
                    showloading: false,
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/Login/Login.vue"),
        meta: {
            title: "登录",
            bgcolor:"#0598D6"
        }
    },
    {
        path: "/mppay",
        name: "mppay",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/Pay/Mppay.vue"),
        meta: {
            title: "微信支付",
            showloading: true
        }
    },
    {
        path: "/coin",
        name: "coinRecord",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/Coin/index.vue"),
        meta: {
            title: "积分记录",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/useredit",
        name: "UserEdit",
        component: () => import(/* webpackChunkName: "user" */"../views/User/Edit/index.vue"),
        meta: {
            title: "信息修改",
            showloading: true,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/userrecord",
        name: "EntryRecord",
        component: () => import(/* webpackChunkName: "user" */"../views/User/EntryRecord/index.vue"),
        meta: {
            title: "我的视频",
            showloading: true,
            requiresAuth: true,
            bgcolor:"#0598D6"
        }
    },
    {
        path: "/orders",
        name: "myOrders",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/Order/Index/index.vue"),
        meta: {
            title: "兑换记录",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/login-by-query/:authinfo?/:redirecturl?",
        name: "LoginByQuery",
        component: () => import(/* webpackChunkName: "common" */"../views/User/LoginByQuery/Index.vue"),
        meta: {
            title: "",
            showloading: true,
            requiresAuth: false
        }
    },
    {
        path: "/order/:orderid",
        name: "orderDetail",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/Order/Detail/index.vue"),
        meta: {
            title: "订单详情",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    }
];
